<template>
    <div
        v-if="visible"
        :class="{'text-caption': isMobile}"
        data-cy="supplier-price"
        class="text-center supplier-price"
        :style="{'white-space': isMobile ? 'pre-line' : ''}"
    >
        <span class="text-no-nowrap"> {{ $t('supplier_price') }}: </span>
        <span>
            {{ price }}
        </span>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class SupplierPrice extends Vue {
        @Prop({required: true}) supplierPrice

        get price() {
            return this.$filters.price(this.supplierPrice)
        }

        get visible() {
            return this.supplierPrice && authStore.companyType && authStore.companyType !== 'CORPORATE'
        }

        get isMobile() {
            return this.$breakpoint.smAndDown
        }
    }

    export default SupplierPrice
</script>

<style scoped>
    span.supplier-price {
        color: rgba(0, 0, 0, 0.6);
    }
</style>
